import { EmpresaPrestacaoServico } from './../../shared/dados-profissionais/model/empresa-prestacao-servico';
import { RecoverDataProposalProfessionalData } from './model/recover-data-proposal/recover-data-proposal-professional-data';
import { RecoverDataProposalPhone } from './model/recover-data-proposal/recover-data-proposal-phone';
import { RecoverDataProposalOwnVehicle } from './model/recover-data-proposal/recover-data-proposal-own-vehicle';
import { RecoverDataProposalAddress } from './model/recover-data-proposal/recover-data-proposal-address';
import { Referencia } from './model/referencia';
import { RecoverDataProposalCompanyProvidingService } from './model/recover-data-proposal/recover-data-proposal-company-providing-service';
import { RecoverDataProposalGuarantor } from './model/recover-data-proposal/recover-data-proposal-guarantor';
import { RecoverDataProposal } from './model/recover-data-proposal/recover-data-proposal';
import { Injectable } from '@angular/core';
import { TipoVeiculoEnum } from '../../produtos/shared/enums/tipo-veiculo.enum';
import { VeiculoSimulacao } from './ficha-cadastro-resultado-parcial/model/proposta/veiculo-simulacao';
import { FichaCadastroTipo } from './ficha-cadastro-tipo';
import { Avalista } from './model/avalista';
import { Cliente } from './model/cliente';
import { Conjuge } from './model/conjuge';
import { Proposta } from './model/proposta';
import { RecuperaGarantia } from './model/recupera/recupera-garantia';
import { RecuperaPessoa } from './model/recupera/recupera-pessoa';
import {
  PendenciaCaminhaoProprio,
  Veiculo,
  VeiculoEmSeuNome,
  VeiculoPendencia,
  VeiculoProprio,
} from './model/veiculo';
import { RecoverDataProposalCustomerReference } from './model/recover-data-proposal/recover-data-proposal-customer-reference';

@Injectable()
export class FichaCadastro {
  public _tipo = FichaCadastroTipo.NOVA;

  //   Passos
  public PASSO_VENDEDOR = 1;
  public PASSO_CLIENTE = 2;
  public PASSO_VEICULO_PROPRIO = 3;
  public PASSO_VEICULO = 4;
  public PASSO_CONSULTANDO_DADOS = 5;
  public PASSO_RESULTADO_PARCIAL = 6;
  public PASSO_DETALHE_CLIENTE = 7;
  public PASSO_CAMINHAO_CLIENTE = 8;
  public PASSO_DETALHE_AVALISTA = 9;
  public PASSO_DETALHE_AVALISTA_2 = 10;
  public PASSO_DETALHE_AVALISTA_3 = 11;
  public PASSO_ENDERECO_CLIENTE = 12;
  public PASSO_ENDERECO_AVALISTA = 13;
  public PASSO_ENDERECO_AVALISTA_2 = 14;
  public PASSO_ENDERECO_AVALISTA_3 = 15;
  public PASSO_OBSERVACAO = 16;
  public PASSO_ANALISE = 17;

  //   Metadados
  public passo: number;
  public garantias = [];
  public codRenavam;
  public tipoSolicitante = '';
  public tipoProduto = '';
  public tipoVeiculo = '';
  public limiteRenda: any = {};
  public idLojista: any = '';
  public idVendedor: any = '';
  public isReadyToSave = false;
  public payload: any = {};
  public fromResultadoParcial = false;
  public idSimulacao: number = null;
  public proposta: any = {};
  [key: string]: any;
  public isClienteAproveitado = true;
  public isVeiculoAproveitado = true;
  public isDetalheClienteAproveitado = true;
  public isDetalheAvalistaAproveitado = true;
  public isEnderecoClienteAproveitado = true;
  public isEnderecoAvalistaAproveitado = true;
  public isFichaAntiga;
  public rendaCliente = 0;
  public getFichaLocalStorage = false;
  public grupo1: string;
  public garantiasOriginais = [];

  // Dados Cliente
  public avalistas: Avalista[] = [];

  public _client = new Cliente();
  public _avalista = new Avalista();
  public _avalistas = [];

  public _cliente: RecuperaPessoa;
  public enderecoCorrespondencia = '1';
  public _classeProfissionalCliente: any;

  // Dados Avalista
  public isAvalista = false;
  public avalistaCpf: string;
  public avalistaDataNascimento: any;
  public avalistaCelular: string;
  public avalistaRenda: number;
  public avalistaParentesco: string = '';
  public _classeProfissionalAvalista: any;
  public rendaAvalista = 0;

  // Dados Cônjuge
  public conjuge: Conjuge;
  public isConjuge = false;

  // Dados Veículo
  public listaVeiculos: Veiculo[] = [];
  public possuiVeiculoEmSeuNome: VeiculoEmSeuNome;
  public possuiVeiculoProprio: VeiculoProprio[];
  public possuiVeiculoProprioTemp: VeiculoEmSeuNome[];
  public informacaoVeiculoProprioCaminhao: PendenciaCaminhaoProprio[];

  public garantia: RecuperaGarantia;

  public error: string;
  // Dados Veículo do getDados
  public listaVeiculosGetDados: VeiculoSimulacao[] = [];
  public listaVeiculosPendencia: VeiculoPendencia[] = [];

  // Recupera dados
  public shoudInitializeCustomer: boolean = true;
  public recoverData: RecoverDataProposal = {
    proposal: {
      customer: {
        id: undefined,
        addresses: undefined,
        companyProvidingService: undefined,
        cpf: undefined,
        customerPpe: undefined,
        fatca: undefined,
        customerReferences: undefined,
        dateOfBirth: undefined,
        documentTypeId: undefined,
        email: undefined,
        equityValue: undefined,
        fatherName: undefined,
        idCivilStatus: undefined,
        income: undefined,
        mailingAddressType: undefined,
        motherName: undefined,
        name: undefined,
        nationalityId: undefined,
        naturalness: undefined,
        naturalnessFederalUnit: undefined,
        ownVehicles: undefined,
        phones: undefined,
        professionalData: undefined,
        rgIe: undefined,
        rgIeDt: undefined,
        rgIeIssuer: undefined,
        transportType: undefined,
        truckDriver: undefined,
        othersTransportType: undefined,
        othersTransportTypeDescription: undefined,
      },
      guarantors: [],
    },
  };

  public setDadosCliente: boolean = false;
  public setDadosAvalistas: boolean[] = [false];
  public avalistasModal: Avalista[] = [];
  public shouldSearchAddress: boolean = false;

  constructor() {
    this.passo = this.PASSO_VENDEDOR;
  }

  //   GETTERS AND SETTER METADADOS
  get solicitanteTipo() {
    return this.tipoSolicitante;
  }

  set solicitanteTipo(data) {
    this.tipoSolicitante = data;
  }

  get produtoTipo() {
    return this.tipoProduto;
  }

  set produtoTipo(data) {
    this.tipoProduto = data;
  }

  get veiculoTipo() {
    return this.tipoVeiculo;
  }

  set veiculoTipo(data) {
    this.tipoVeiculo = data;
  }

  get rendaLimite() {
    return this.limiteRenda;
  }

  set rendaLimite(data) {
    this.limiteRenda = data;
  }

  get IDLojista() {
    return this.idLojista;
  }

  set IDLojista(data) {
    this.idLojista = data;
  }

  get IDVendedor() {
    return this.idVendedor;
  }

  set IDVendedor(data) {
    this.idVendedor = data;
  }

  // GETTERS AND SETTER DADOS CLIENTES

  set $client(data) {
    this._client = data;
  }
  set $avalista(data) {
    this._avalista = data;
  }

  // GETTERS AND SETTER DADOS AVALISTA
  get cpfAvalista() {
    return this.avalistaCpf;
  }
  set cpfAvalista(data) {
    this.avalistaCpf = data;
  }

  get dataNascimentoAvalista() {
    return this.avalistaDataNascimento;
  }
  set dataNascimentoAvalista(data) {
    // espera receber data no formato UTC DD/MM/AAAA
    this.avalistaDataNascimento = data;
  }

  get telefoneCelularAvalista() {
    return this.avalistaCelular;
  }

  set telefoneCelularAvalista(data) {
    this.avalistaCelular = data;
  }

  get rendaComprovadaAvalista() {
    return this.avalistaRenda;
  }

  set rendaComprovadaAvalista(data) {
    this.avalistaRenda = data;
  }
  get parentescoAvalista() {
    return this.avalistaParentesco;
  }

  set parentescoAvalista(data) {
    this.avalistaParentesco = data;
  }

  // GETTERS AND SETTER DADOS VEICULO
  get veiculos() {
    return this.listaVeiculos;
  }
  set veiculos(data) {
    this.listaVeiculos = data;
  }

  get veiculoEmSeuNome() {
    return this.possuiVeiculoEmSeuNome;
  }
  set veiculoEmSeuNome(data) {
    this.possuiVeiculoEmSeuNome = data;
  }

  get veiculoProprio() {
    return this.possuiVeiculoProprio;
  }
  set veiculoProprio(data) {
    this.possuiVeiculoProprio = data;
  }

  get veiculoProprioTemp() {
    return this.possuiVeiculoProprioTemp;
  }

  get errorStatus() {
    return this.error;
  }

  setErrorStatus(errorStatus) {
    this.error = errorStatus;
  }

  // set hasUsado(data) {
  //   this.isUsado = data;
  //   this.isZeroKm = false;
  //   this.isUtilizacaoAgropecuaria = false;
  // }

  set veiculoProprioTemp(data) {
    this.possuiVeiculoProprioTemp = data;
  }

  get veiculoProprioCaminhao() {
    return this.informacaoVeiculoProprioCaminhao;
  }
  set veiculoProprioCaminhao(data) {
    this.informacaoVeiculoProprioCaminhao = data;
  }

  get tipo(): FichaCadastroTipo {
    return this._tipo;
  }

  // GETTERS AND SETTER VEICULO VINDO DO GETDADOS
  get veiculosGetDados() {
    return this.listaVeiculosGetDados;
  }
  set veiculosGetDados(data) {
    this.listaVeiculosGetDados = data;
  }
  get veiculosPendencia() {
    return this.listaVeiculosPendencia;
  }
  set veiculosPendencia(data) {
    this.listaVeiculosPendencia = data;
  }

  passoAlterarVeiculo() {
    // this._tipo = FichaCadastroTipo.ALTERACAO_VEICULO;
    this.passo = this.PASSO_CONSULTANDO_DADOS;
  }

  passoCorrigirFipeNotFound() {
    this._tipo = FichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND;
    this.passo = this.PASSO_VEICULO;
  }

  get isPassoCorrigirFipeNotFound(): boolean {
    return this._tipo === FichaCadastroTipo.CORRECAO_FIPE_NOT_FOUND;
  }

  passoCorrigirPLacaInvalida() {
    this._tipo = FichaCadastroTipo.CORRECAO_PLACA_INVALIDA;
    this.passo = this.PASSO_VEICULO;
  }

  passoRetornarResultadoParcial() {
    this.passo = this.PASSO_RESULTADO_PARCIAL;
  }

  get isPassoCorrigirPLacaInvalida(): boolean {
    return this._tipo === FichaCadastroTipo.CORRECAO_PLACA_INVALIDA;
  }

  getPasso(): number {
    return this.passo;
  }

  setPasso(passo) {
    this.passo = passo;
  }

  getTipoSolicitante(): string {
    return this.tipoSolicitante;
  }

  setTipoSolicitante(tipoSolicitante: string) {
    this.tipoSolicitante = tipoSolicitante;
  }

  getTipoProduto(): string {
    return this.tipoProduto;
  }

  setTipoProduto(tipoProduto: string) {
    this.tipoProduto = tipoProduto;
  }

  getTipoVeiculo(): string {
    return this.tipoVeiculo;
  }

  setTipoVeiculo(tipoVeiculo: string) {
    this.tipoVeiculo = tipoVeiculo;
  }

  getIdLojista() {
    return this.idLojista;
  }

  setIdLojista(idLojista) {
    this.idLojista = idLojista;
  }

  getIdVendedor() {
    return this.idVendedor;
  }

  setIdVendedor(idVendedor) {
    this.idVendedor = idVendedor;
  }

  hasAvalista(): boolean {
    return this.isAvalista;
  }

  setAvalista(avalista: boolean) {
    this.isAvalista = avalista;
  }

  getConjuge(): boolean {
    return this.isConjuge;
  }

  setConjuge(conjuge: boolean) {
    this.isConjuge = conjuge;
  }

  setPayload(key: string, value: any) {
    this.payload[key] = value;
  }

  getPayload(): any {
    return this.payload;
  }

  replacePayload(payload: any) {
    this.payload = payload;
  }

  clearPayLoad() {
    this.payload = {};
  }

  get isPesados(): boolean {
    return this.tipoVeiculo === TipoVeiculoEnum.PESADOS;
  }

  onClickPrevious() {
    const passo = this.getPasso();
    let auxPasso = 1;

    switch (true) {
      case this.isPesados &&
        passo === this.PASSO_DETALHE_AVALISTA &&
        (!this.possuiVeiculoProprio || this.possuiVeiculoProprio.length === 0):

      case this.avalistas.length === 2 && passo === this.PASSO_ENDERECO_CLIENTE:

      case this.avalistas.length === 2 && passo === this.PASSO_OBSERVACAO:

      case !this.isPesados && passo === this.PASSO_VEICULO:
        auxPasso = 2;
        break;

      case !this.isAvalista &&
        passo === this.PASSO_ENDERECO_CLIENTE &&
        (!this.possuiVeiculoProprio || this.possuiVeiculoProprio.length === 0):
        auxPasso = 5;
        break;

      case !this.isAvalista && passo === this.PASSO_ENDERECO_CLIENTE:

      case !this.isAvalista && passo === this.PASSO_OBSERVACAO:
        auxPasso = 4;
        break;

      case this.avalistas.length === 1 && passo === this.PASSO_ENDERECO_CLIENTE:

      case this.avalistas.length === 1 && passo === this.PASSO_OBSERVACAO:
        auxPasso = 3;
        break;

      default:
        auxPasso = 1;
    }

    this.setPasso(passo - auxPasso);
    window.scroll({ top: 0, behavior: 'smooth' });
  }

  onClickNext() {
    const passo = this.getPasso();
    let auxPasso = 1;

    switch (true) {
      case !this.isPesados && passo === this.PASSO_CLIENTE:

      case !this.isPesados &&
        this.isAvalista &&
        passo === this.PASSO_DETALHE_CLIENTE:

      case this.isPesados &&
        this.isAvalista &&
        passo === this.PASSO_DETALHE_CLIENTE &&
        (!this.possuiVeiculoProprio || this.possuiVeiculoProprio.length === 0):

      case this.avalistas.length === 2 &&
        passo === this.PASSO_DETALHE_AVALISTA_2:

      case this.avalistas.length === 2 &&
        passo === this.PASSO_ENDERECO_AVALISTA_2:
        auxPasso = 2;
        break;

      case !this.isAvalista &&
        passo === this.PASSO_DETALHE_CLIENTE &&
        (!this.possuiVeiculoProprio || this.possuiVeiculoProprio.length === 0):
        auxPasso = 5;
        break;

      case !this.isAvalista && passo === this.PASSO_ENDERECO_CLIENTE:

      case this.isPesados &&
        !this.isAvalista &&
        passo === this.PASSO_CAMINHAO_CLIENTE:
        auxPasso = 4;
        break;

      case this.avalistas.length === 1 && passo === this.PASSO_DETALHE_AVALISTA:

      case this.avalistas.length === 1 &&
        passo === this.PASSO_ENDERECO_AVALISTA:
        auxPasso = 3;
        break;

      default:
        auxPasso = 1;
    }

    this.setPasso(passo + auxPasso);
    window.scroll({ top: 0, behavior: 'smooth' });

    this.callRecoverDataCustomer();
  }

  public callRecoverDataCustomer() {
    this.assignDataCustomer();
    this.assignDataGuarantors();
  }

  private assignDataCustomer() {
    this.recoverData.proposal.id = this.proposta.id;
    this.recoverData.proposal.customer.id = this._client.id;
    this.recoverData.proposal.customer.addresses =
      this.getRecoverDataProposalAddress(
        this._client.enderecos,
        [],
        this._client.enderecoCorrespondencia ? false : true
      );
    this.recoverData.proposal.customer.addresses =
      this.getRecoverDataProposalAddress(
        this._client.enderecoCorrespondencia,
        this.recoverData.proposal.customer.addresses,
        this._client.enderecoCorrespondencia ? true : false
      );
    this.recoverData.proposal.customer.companyProvidingService =
      this.getCompanyProvidingService(this._client.empresaPrestacaoServico);
    this.recoverData.proposal.customer.cpf = this._client.cpf;
    this.recoverData.proposal.customer.customerPpe = this._client.clientePpe;
    this.recoverData.proposal.customer.fatca = this._client.fatca;
    this.recoverData.proposal.customer.customerReferences =
      this.getCustomerReferences(this._client.clienteReferencias);
    this.recoverData.proposal.customer.dateOfBirth = this._client.dataNascimento
      ? new Date(
          this._client.dataNascimento.substring(4),
          Number(this._client.dataNascimento.substring(2, 4)) - 1,
          this._client.dataNascimento.substring(0, 2)
        ).getTime()
      : undefined;
    this.recoverData.proposal.customer.documentTypeId =
      this._client.idTipoDocumento;
    this.recoverData.proposal.customer.email = this._client.email;
    this.recoverData.proposal.customer.equityValue = String(
      this._client.valorPatrimonio
    );
    this.recoverData.proposal.customer.fatherName = this._client.nomePai;
    this.recoverData.proposal.customer.idCivilStatus =
      this._client.idEstadoCivil;
    this.recoverData.proposal.customer.income = Number(this._client.renda);
    this.recoverData.proposal.customer.mailingAddressType =
      this._client.tipoEnderecoCorrespondencia;
    this.recoverData.proposal.customer.motherName = this._client.nomeMae;
    this.recoverData.proposal.customer.name = this._client.nome;
    this.recoverData.proposal.customer.nationalityId =
      this._client.idNacionalidade;
    this.recoverData.proposal.customer.naturalness = this._client.naturalDe;
    this.recoverData.proposal.customer.naturalnessFederalUnit =
      this._client.naturalDeUf;
    (this.recoverData.proposal.customer.ownVehicles =
      this.getRecoverDataProposalOwnVehicle(this.veiculoProprioCaminhao)),
      (this.recoverData.proposal.customer.phones =
        this.getRecoverDataProposalPhone(this._client.telefones));
    this.recoverData.proposal.customer.professionalData =
      this.getRecoverDataProposalProfessionalData(
        this._client.dadoProfissional
      );
    this.recoverData.proposal.customer.rgIe = this._client.rgIe;
    this.recoverData.proposal.customer.rgIeDt = this._client.rgIeData
      ? new Date(
          this._client.rgIeData.substring(4),
          Number(this._client.rgIeData.substring(2, 4)) - 1,
          this._client.rgIeData.substring(0, 2)
        ).getTime()
      : undefined;
    this.recoverData.proposal.customer.rgIeIssuer = this._client.rgIeEmissor;
    this.recoverData.proposal.customer.transportType =
      this._client.tipoTransporte;
    this.recoverData.proposal.customer.truckDriver =
      this._client.condutorCaminhao;
    this.recoverData.proposal.customer.othersTransportType =
      this._client.tipoTransporte;
    this.recoverData.proposal.customer.othersTransportTypeDescription =
      this._client.tipoTransporteOutro;
  }

  private assignDataGuarantors() {
    const guarantors = [];
    if (this.avalistas.length > 0) {
      const avalistas: RecoverDataProposalGuarantor[] = [];
      this.avalistas.forEach((avalista: Avalista) => {
        avalistas.push({
          addresses: [
            ...this.getRecoverDataProposalAddress(
              avalista.enderecos,
              [],
              avalista.enderecoCorrespondencia ? false : true
            ),
            ...this.getRecoverDataProposalAddress(
              avalista.enderecoCorrespondencia,
              [],
              avalista.enderecoCorrespondencia ? true : false
            ),
          ],
          id: avalista.id,
          comments: '',
          cpf: avalista.cpf,
          customerPpe: avalista.clientePpe,
          customerReferences: this.getCustomerReferences(
            avalista.avalistaReferencia
          ),
          dateOfBirth: avalista.dataNascimento
            ? new Date(
                avalista.dataNascimento.substring(4),
                Number(avalista.dataNascimento.substring(2, 4)) - 1,
                avalista.dataNascimento.substring(0, 2)
              ).getTime()
            : undefined,
          documentTypeId: avalista.idTipoDocumento,
          email: avalista.email,
          equityValue: String(avalista.valorPatrimonio),
          fatherName: avalista.nomePai,
          idCivilStatus: avalista.idEstadoCivil,
          income: avalista.renda,
          mailingAddressType: avalista.tipoEnderecoCorrespondencia,
          motherName: avalista.nomeMae,
          name: avalista.nome,
          nationalityId: avalista.idNacionalidade,
          naturalness: avalista.naturalDe,
          naturalnessFederalUnit: avalista.naturalDeUf,
          ownVehicles: this.recoverDataProposalOwnVehicleSimulation(
            avalista.veiculoEmSeuNome
          ),
          phones: this.getRecoverDataProposalPhone(avalista.telefones),
          professionalData: this.getRecoverDataProposalProfessionalData(
            avalista.dadoProfissional
          ),
          rgIe: avalista.rgIe,
          rgIeDt: avalista.rgIeData
            ? new Date(
                avalista.rgIeData.substring(4),
                Number(avalista.rgIeData.substring(2, 4)) - 1,
                avalista.rgIeData.substring(0, 2)
              ).getTime()
            : undefined,
          rgIeIssuer: avalista.rgIeEmissor,
          transportType: 0,
          truckDriver: '',
          relationship: Number(avalista.grauParentescoCliente),
        });
      });
      guarantors.push(...avalistas);
    }
    if (this.avalistasModal && this.avalistasModal.length > 0) {
      const avalistas: RecoverDataProposalGuarantor[] = [];
      this.avalistasModal.forEach((avalista: Avalista) => {
        avalistas.push({
          addresses: [
            ...this.getRecoverDataProposalAddress(
              avalista.enderecos,
              [],
              avalista.enderecoCorrespondencia ? false : true
            ),
            ...this.getRecoverDataProposalAddress(
              avalista.enderecos,
              [],
              avalista.enderecoCorrespondencia ? true : false
            ),
          ],
          id: avalista.id,
          comments: '',
          cpf: avalista.cpf,
          customerPpe: avalista.clientePpe,
          customerReferences: this.getCustomerReferences(
            avalista.avalistaReferencia
          ),
          dateOfBirth: avalista.dataNascimento,
          documentTypeId: avalista.idTipoDocumento,
          email: avalista.email,
          equityValue: String(avalista.valorPatrimonio),
          fatherName: avalista.nomePai,
          idCivilStatus: avalista.idEstadoCivil,
          income: avalista.renda,
          mailingAddressType: avalista.tipoEnderecoCorrespondencia,
          motherName: avalista.nomeMae,
          name: avalista.nome,
          nationalityId: avalista.idNacionalidade,
          naturalness: avalista.naturalDe,
          naturalnessFederalUnit: avalista.naturalDeUf,
          ownVehicles: this.recoverDataProposalOwnVehicleModal(
            avalista.veiculoEmSeuNome
          ),
          phones: this.getRecoverDataProposalPhone(avalista.telefones),
          professionalData: this.getRecoverDataProposalProfessionalData(
            avalista.dadoProfissional
          ),
          rgIe: avalista.rgIe,
          rgIeDt: avalista.rgIeData,
          rgIeIssuer: avalista.rgIeEmissor,
          transportType: 0,
          truckDriver: '',
          relationship: Number(avalista.grauParentescoCliente),
        });
      });
      guarantors.push(...avalistas);
    }
    this.recoverData.proposal.guarantors = guarantors;
  }

  public getRecoverDataProposalAddress(
    endereco: any,
    previousArray: any[],
    correspondence: boolean
  ): RecoverDataProposalAddress[] {
    const data: RecoverDataProposalAddress[] =
      previousArray && previousArray.length > 0 ? previousArray : [];
    if (endereco && endereco.endereco) {
      data.push({
        correspondence,
        address: endereco.endereco,
        addressTypeId: endereco.idTipoEndereco,
        city: endereco.cidade,
        complement: endereco.complemento,
        federalUnit: endereco.uf,
        neighborhood: endereco.bairro,
        number: endereco.numero,
        residenceCondition: Number(endereco.condicaoResidencia),
        residenceTime: Number(endereco.tempoResidencia),
        sequence: 0,
        singleZipCode: endereco.cep,
        zip: '',
      });
    }
    return data;
  }

  private getCompanyProvidingService(
    prestadora: EmpresaPrestacaoServico
  ): RecoverDataProposalCompanyProvidingService {
    const data: RecoverDataProposalCompanyProvidingService =
      {} as RecoverDataProposalCompanyProvidingService;
    if (prestadora) {
      data.ddd = prestadora.ddd;
      data.name = prestadora.nome;
      data.phone = prestadora.telefone;
      data.transportType = prestadora.tipoTransporte;
      data.othersTransportTypeDescription = prestadora.tipoTransporteOutro;
    }
    return data;
  }

  public getCustomerReferences(
    reference: any
  ): RecoverDataProposalCustomerReference[] {
    const data: RecoverDataProposalCustomerReference[] = [];
    if (reference && reference.length > 0) {
      reference.forEach((ref: Referencia) => {
        if (ref.idGrauRelacionamento) {
          const phones: RecoverDataProposalPhone[] = [
            {
              categoryId: ref['telefones']
                ? ref['telefones'][0].idCategoria
                : ref['telefone']
                ? ref['telefone'].idCategoria
                : undefined,
              categoryPhoneId: ref['telefones']
                ? ref['telefones'][0].idCategoriaTelefone
                : ref['telefone']
                ? ref['telefone'].idCategoriaTelefone
                : undefined,
              ddd: ref['telefones']
                ? ref['telefones'][0].ddd
                : ref['telefone']
                ? ref['telefone'].ddd
                : undefined,
              number: ref['telefones']
                ? ref['telefones'][0].numero
                : ref['telefone']
                ? ref['telefone'].numero
                : undefined,
              phoneTypeId: ref['telefones']
                ? ref['telefones'][0].idTipoTelefone
                : ref['telefone']
                ? ref['telefone'].idTipoTelefone
                : undefined,
            },
          ];
          data.push({
            phones,
            name: ref.nome,
            relationshipDegreeId: ref.idGrauRelacionamento,
          });
        }
      });
    } else if (
      reference &&
      (reference.idGrauRelacionamento || reference.nome)
    ) {
      const phones: RecoverDataProposalPhone[] = [
        {
          categoryId: '3',
          categoryPhoneId: '3',
          ddd: !reference['telefone'].ddd
            ? reference['telefone'].substring(0, 2)
            : reference['telefone'].ddd,
          number: !reference['telefone'].numero
            ? reference['telefone'].substring(2)
            : reference['telefone'].numero,
          phoneTypeId: '1',
        },
      ];
      data.push({
        phones,
        name: reference.nome,
        relationshipDegreeId: reference.idGrauRelacionamento,
      });
    }
    return data;
  }

  private getRecoverDataProposalOwnVehicle(
    veiculoEmSeuNome: any
  ): RecoverDataProposalOwnVehicle[] {
    const data: RecoverDataProposalOwnVehicle[] = [];
    if (veiculoEmSeuNome && veiculoEmSeuNome.length > 0) {
      veiculoEmSeuNome.forEach((vehicle: PendenciaCaminhaoProprio) => {
        if (vehicle.info) {
          data.push({
            OwnsTime: vehicle.info.tempoCaminhao,
            amountPaidParcels: vehicle.quitado.parcelasQuitada,
            amountParcels: vehicle.quitado.totalParcela,
            brand: {
              description: vehicle.info.veiculoMarca
                ? vehicle.info.veiculoMarca.descricao
                : undefined,
              id: vehicle.info.veiculoMarca
                ? Number(vehicle.info.veiculoMarca.id)
                : undefined,
            },
            hasImplement: vehicle.implemento.veiculoImplemento ? 'S' : 'N',
            implementBrand: vehicle.implemento.veiculoMarca
              ? Number(vehicle.implemento.veiculoMarca.id)
              : undefined,
            implementYear: Number(vehicle.implemento.veiculoAno),
            model: {
              id: vehicle.info.veiculoModelo
                ? Number(vehicle.info.veiculoModelo.id)
                : undefined,
              description: vehicle.info.veiculoModelo
                ? vehicle.info.veiculoModelo.descricao
                : undefined,
            },
            modelYear: Number(vehicle.info.veiculoAno),
            paid: vehicle.quitado.veiculoQuitado ? 'S' : 'N',
            plate: vehicle.info.veiculoPlaca,
            valueParcels: vehicle.quitado.valorParcela,
            version: {
              description: vehicle.info.veiculoVersao
                ? vehicle.info.veiculoVersao.descricao
                : '',
              id: vehicle.info.veiculoVersao
                ? Number(vehicle.info.veiculoVersao.id)
                : 0,
            },
            creditorName: vehicle.quitado.banco
              ? String(vehicle.quitado.banco.codigo || vehicle.quitado.banco.id)
              : undefined,
            implementModel: vehicle.implemento.veiculoModelo
              ? Number(vehicle.implemento.veiculoModelo.id)
              : undefined,
            status: undefined,
            category: undefined,
            value: undefined,
          });
        }
      });
    }
    return data;
  }

  recoverDataProposalOwnVehicleModal(veiculoEmSeuNome: any) {
    const data: RecoverDataProposalOwnVehicle[] = [];
    if (veiculoEmSeuNome && veiculoEmSeuNome.length > 0) {
      veiculoEmSeuNome.forEach((vehicle) => {
        if (vehicle.anoModelo) {
          data.push({
            OwnsTime: undefined,
            amountPaidParcels: undefined,
            amountParcels: undefined,
            brand: {
              description: vehicle.marca ? vehicle.marca.descricao : undefined,
              id: vehicle.marca ? Number(vehicle.marca.id) : undefined,
            },
            hasImplement: undefined,
            implementBrand: undefined,
            implementYear: undefined,
            model: {
              id: vehicle.modelo ? Number(vehicle.modelo.id) : undefined,
              description: vehicle.modelo
                ? vehicle.modelo.descricao
                : undefined,
            },
            modelYear: Number(vehicle.anoModelo),
            paid: undefined,
            plate: vehicle.placa,
            valueParcels: undefined,
            version: {
              description: vehicle.versao
                ? vehicle.versao.descricao
                : undefined,
              id: vehicle.versao ? Number(vehicle.versao.id) : undefined,
            },
            creditorName: undefined,
            implementModel: undefined,
            status: undefined,
            category: {
              description: vehicle.categoria
                ? vehicle.categoria.descricao
                : undefined,
              id: vehicle.categoria ? Number(vehicle.categoria.id) : undefined,
            },
            value: undefined,
          });
        }
      });
    }
    return data;
  }

  recoverDataProposalOwnVehicleSimulation(
    ownVehicle: VeiculoSimulacao | VeiculoSimulacao[]
  ) {
    let veiculoEmSeuNome: any = ownVehicle;
    if (Array.isArray(veiculoEmSeuNome)) {
      veiculoEmSeuNome = ownVehicle[0];
    }
    const data: RecoverDataProposalOwnVehicle[] = [];
    if (veiculoEmSeuNome) {
      data.push({
        OwnsTime: undefined,
        amountPaidParcels: undefined,
        amountParcels: undefined,
        brand: {
          description: veiculoEmSeuNome.marca
            ? veiculoEmSeuNome.marca.getDescricao()
            : undefined,
          id: veiculoEmSeuNome.marca
            ? Number(veiculoEmSeuNome.marca.getId())
            : undefined,
        },
        hasImplement: undefined,
        implementBrand: undefined,
        implementYear: undefined,
        model: {
          id: veiculoEmSeuNome.modelo
            ? Number(veiculoEmSeuNome.modelo.getId())
            : undefined,
          description: veiculoEmSeuNome.modelo
            ? veiculoEmSeuNome.modelo.getDescricao()
            : undefined,
        },
        modelYear: Number(veiculoEmSeuNome.anoModelo),
        paid: undefined,
        plate: veiculoEmSeuNome.placa,
        valueParcels: undefined,
        version: {
          description: veiculoEmSeuNome.versao
            ? veiculoEmSeuNome.versao.getDescricao()
            : undefined,
          id: veiculoEmSeuNome.versao
            ? Number(veiculoEmSeuNome.versao.getId())
            : undefined,
        },
        creditorName: undefined,
        implementModel: undefined,
        status: undefined,
        category: {
          description: veiculoEmSeuNome.categoria
            ? veiculoEmSeuNome.categoria.getDescricao()
            : undefined,
          id: veiculoEmSeuNome.categoria
            ? Number(veiculoEmSeuNome.categoria.getId())
            : undefined,
        },
        value: undefined,
      });
    }
    return data;
  }

  private getRecoverDataProposalPhone(phones: any): RecoverDataProposalPhone[] {
    const data: RecoverDataProposalPhone[] = [];
    if (phones) {
      Object.keys(phones).forEach((key) => {
        if (!phones[key])
          return;
        if (key === 'celular') {
          data.push({
            ddd: phones[key].substring(0, 2),
            number: phones[key].substring(2),
            categoryId: '3',
            phoneTypeId: '1',
            categoryPhoneId: '3',
          });
        }
        if (key === 'residencial') {
          data.push({
            ddd: phones[key].substring(0, 2),
            number: phones[key].substring(2),
            categoryId: '1',
            phoneTypeId: '2',
            categoryPhoneId: '1',
          });
        }
        if (key === 'comercial') {
          data.push({
            ddd: phones[key].substring(0, 2),
            number: phones[key].substring(2),
            categoryId: '2',
            phoneTypeId: '2',
            categoryPhoneId: '2',
          });
        }
        if (key === 'celularAdicional') {
          data.push({
            ddd: phones[key].substring(0, 2),
            number: phones[key].substring(2),
            categoryId: '11',
            phoneTypeId: '1',
            categoryPhoneId: '11',
          });
        }
      });
    }
    return data;
  }

  private getRecoverDataProposalPhoneProfessionalData(
    phones: any
  ): RecoverDataProposalPhone {
    const data: RecoverDataProposalPhone = {} as RecoverDataProposalPhone;
    if (phones) {
      data.ddd = phones.substring(0, 2);
      data.number = phones.substring(2);
      data.categoryPhoneId = '2';
      data.phoneTypeId = '2';
    }
    return data;
  }

  private getRecoverDataProposalProfessionalData(
    dadosProfissonal: any
  ): RecoverDataProposalProfessionalData {
    const data: RecoverDataProposalProfessionalData =
      {} as RecoverDataProposalProfessionalData;
    if (dadosProfissonal && dadosProfissonal.idProfissao) {
      data.ProfessionId = dadosProfissonal.idProfissao;
      data.companyName = dadosProfissonal.nomeEmpresa;
      data.experienceIndustryTime = dadosProfissonal.tempoExperiencia
        ? dadosProfissonal.tempoExperiencia.valorNumerico
        : undefined;
      data.familyInBusiness = dadosProfissonal.familiaresRamo;
      data.phone = dadosProfissonal.empresa.telefone
        ? this.getRecoverDataProposalPhoneProfessionalData(
            dadosProfissonal.empresa.telefone
          )
        : undefined;
      data.professionGroupId = dadosProfissonal.idGrupoProfissao;
      data.professionalClassId = dadosProfissonal.classeProfissional
        ? dadosProfissonal.classeProfissional.id
        : undefined;
      if (
        dadosProfissonal.empresa &&
        dadosProfissonal.empresa.endereco &&
        dadosProfissonal.empresa.endereco.endereco
      ) {
        if (!data.address) {
          data.address = {} as RecoverDataProposalAddress;
        }
        data.address.address = dadosProfissonal.empresa.endereco.endereco;
        data.address.federalUnit = dadosProfissonal.empresa.endereco.uf;
        data.address.city = dadosProfissonal.empresa.endereco.cidade;
        data.address.neighborhood = dadosProfissonal.empresa.endereco.bairro;
        data.address.singleZipCode = dadosProfissonal.empresa.endereco.cep;
        data.address.number = dadosProfissonal.empresa.endereco.numero;
        data.address.complement = dadosProfissonal.empresa.endereco.complemento;
      }
    }
    return data;
  }

  isSelected(passo): boolean {
    return this.passo === passo;
  }

  selectPasso(passo) {
    this.passo = passo;
  }

  initializeProposta(proposta: Proposta) {
    this.proposta = proposta;
  }

  getProposta(): Proposta {
    return this.proposta;
  }

  setToSave() {
    this.isReadyToSave = true;
  }

  unsetToSave() {
    this.isReadyToSave = false;
  }

  getIsReadyToSave(): boolean {
    return this.isReadyToSave;
  }

  setCliente(obj: any) {
    this._cliente = new RecuperaPessoa(obj);
    this.isClienteAproveitado = false;
  }

  getCliente(): RecuperaPessoa {
    return this._cliente;
  }

  setGarantia(obj: any) {
    this.garantia = new RecuperaGarantia(obj);
    this.isVeiculoAproveitado = false;
  }

  getGarantia(): RecuperaGarantia {
    return this.garantia;
  }

  setIdSimulacao(idSimulacao: number) {
    this.idSimulacao = idSimulacao;
  }

  getIdSimulacao(): number {
    return this.idSimulacao;
  }

  get fichaAntiga() {
    return this.isFichaAntiga;
  }

  set fichaAntiga(data) {
    this.isFichaAntiga = data;
  }

  set classeProfissionalCliente(classeProfissional: any) {
    this._classeProfissionalCliente = classeProfissional;
  }

  get classeProfissionalCliente(): any {
    return this._classeProfissionalCliente;
  }

  set classeProfissionalAvalista(classeProfissional: any) {
    this._classeProfissionalAvalista = classeProfissional;
  }

  get classeProfissionalAvalista(): any {
    return this._classeProfissionalAvalista;
  }

  formatDateToString(date) {
    let ret: string;
    if (date) {
      // 01, 02, 03, ... 29, 30, 31
      const dd = (date.getDate() < 10 ? '0' : '') + date.getDate();
      // 01, 02, 03, ... 10, 11, 12
      const MM = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
      // 1970, 1971, ... 2015, 2016, ...
      const yyyy = date.getFullYear();
      // create the format you want
      ret = `${dd}${MM}${yyyy}`;
    } else {
      ret = undefined;
    }
    return ret;
  }
}
